import { NOTIFICATION } from 'modules/alert/constants';
import { showSuccessMessage, showUncaughtErrorMessage } from 'modules/alert/utils';
import { useModal } from 'modules/modals/ModalProvider';
import { useRemoveRelatedThreadMutation } from 'modules/relatedThreads/relatedThreadsApi';
import React from 'react';
import colors from 'theme/colors';
import { Button, Group, Stack, Text } from 'ui';

interface IDeleteThreadProps {
  relatedThreadId: number;
  threadId: string;
}

const DeleteRelatedThread: React.FC<IDeleteThreadProps> = ({ threadId, relatedThreadId }) => {
  const [removeRelatedThread, { isLoading }] = useRemoveRelatedThreadMutation();
  const { close } = useModal();
  const handleRemoveThread = async () => {
    try {
      await removeRelatedThread({ threadId, relatedThreadId }).unwrap();
      close();
      showSuccessMessage(NOTIFICATION.RELATED_THREAD_DELETED);
    } catch {
      showUncaughtErrorMessage();
    }
  };

  return (
    <Stack gap="20px">
      <Text size="lg" color={colors.gray2}>
        Are you sure you want to delete this related thread?
      </Text>
      <Group justify="end" gap="15px">
        <Button
          color={colors.dark2}
          onClick={() => close()}
          cypressAttribute="modal-delete-related-thread-cancel-btn"
        >
          Cancel
        </Button>
        <Button
          color={colors.red2}
          onClick={handleRemoveThread}
          cypressAttribute="modal-delete-related-thread-remove-btn"
        >
          {isLoading ? 'Removing' : 'Remove'}
        </Button>
      </Group>
    </Stack>
  );
};

export default DeleteRelatedThread;
